module.exports = __webpack_public_path__ + "static/ASHI_certified-cb415ebe1185c97dde015d140e28c0ea.png";